var _effectorFileName = "/builds/gmini/front-ui-kit/src/utils/isFieldIncludedToSearch.ts";
export const isFieldIncludedToSearch = (field, searchValue) => {
  var _field$trim;

  return field === null || field === void 0 ? void 0 : (_field$trim = field.trim) === null || _field$trim === void 0 ? void 0 : _field$trim.call(field).toLocaleLowerCase().includes(searchValue.trim().toLocaleLowerCase());
};